import type { PagedResultDto } from "@services/dto/pagedResultDto"
import groupService from "@services/master-data/groupService"

import { action, makeAutoObservable, observable } from "mobx"
import { appDataStoreInstance as appDataStore } from "../appDataStore"

class GroupStore {
  @observable isLoading!: boolean
  @observable tableData!: PagedResultDto<any>
  @observable customersInGroup!: PagedResultDto<any>
  @observable detailData!: any

  constructor() {
    makeAutoObservable(this)
    this.tableData = { items: [], totalCount: 0 }
    this.customersInGroup = { items: [], totalCount: 0 }
  }

  @action
  async createOrUpdate(body: any) {
    this.isLoading = true
    const result = await groupService
      .createOrUpdate(body)
      .finally(() => (this.isLoading = false))
    this.detailData = result
    if (!body.id) {
      this.tableData.items.push(result)
    } else {
      this.tableData.items = this.tableData.items.map((x) => {
        if (x.id === body.id) x = result
        return x
      })
    }
    appDataStore.getListGroup()
  }

  @action
  async emptyDetail() {
    this.detailData = {
      id: 0,
    }
  }

  @action
  async active(id: number, isActive) {
    this.isLoading = true
    await groupService
      .activate(id, isActive)
      .finally(() => (this.isLoading = false))
    appDataStore.getListGroup()
  }

  @action
  async get(id: number) {
    this.isLoading = true
    const result = await groupService
      .get(id)
      .finally(() => (this.isLoading = false))
    this.detailData = result
  }

  @action
  async getAll(params: any) {
    this.isLoading = true
    const result = await groupService
      .getAll(params)
      .finally(() => (this.isLoading = false))
    this.tableData = result
  }
  @action
  async getAllCustomersByGroup(params: any) {
    this.isLoading = true
    const result = await groupService
      .getAllCustomersByGroup(params)
      .finally(() => (this.isLoading = false))
    this.customersInGroup = result
  }
}

export default GroupStore
